import React, { useState, useEffect, useContext, Fragment } from 'react'
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import ListGroup from 'react-bootstrap/ListGroup';
import { FaRegTrashAlt } from 'react-icons/fa';
import { ObjModal } from '../../../../contexts';
import { BsDot } from 'react-icons/bs';

import { styled } from '@mui/material/styles';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import KeyboardArrowRightSharpIcon from '@mui/icons-material/KeyboardArrowRightSharp';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import { removeBorrowersFromLoan } from '../../../../common/api';
import { toast } from 'react-toastify';


const Borrowers = ( { orgId, aid, uid, contacts } ) => {
    const { obj, openModal, closeModal, setModal } = useContext( ObjModal );
    const [ expanded, setExpanded ] = useState( false );
    const [ borrs, setBorrs ] = useState( [] );
    
    const formatName = ( cid ) => {
        const c = contacts[cid]; // .find( con => con.cid === cid );
        if ( !c ) {
            return null;
        }
        let n = c.firstname;
        if ( c.namePreferred && c.namePreferred.length ) {
            n = c.namePreferred;
        }
        if ( c.lastname && c.lastname.length ) {
            n += ' ' + c.lastname;
        }
        
        return n.trim();
    };

    const trash = async ( lid, bid ) => {
        const removed = await removeBorrowersFromLoan( aid, uid, lid, [ bid ] );
        if ( removed.length ) {
            toast.success( `Your borrower has been removed`, { theme: 'dark' } );
            // window.location.reload( false );
        }
    };

    const handleModal = ( t ) => {
        let shouldOpen = true;

        switch ( t ) {
            case 'task':
                // setModal( <AddGift close={closeModal} /> ); 
                break;

            default:
                console.log( 'Unknown modal type: ' + t );
                shouldOpen = false;
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    const displayJungoCoBo = ( cid, bid ) => {
        const c = contacts[cid]; //.find( f => f.cid === cid );
        
        if ( c && c.firstnamePartner1 && c.firstnamePartner1.length ) {
            return displayBorrowerRow( 'Co-Borrower', cid, bid, `${c.firstnamePartner1} ${c.lastnamePartner1}`, true );
        } else if ( c && c.namePartner1 ) {
            return displayBorrowerRow( 'Co-Borrower', cid, bid, c.namePartner1, true );
        }

        return <Fragment />;
    }

    const displayEmail = ( cid, partner = false ) => {
        const c = contacts[cid]; // .find( f => f.cid === cid );
        let e = c?.email;

        if ( partner ) {
            e = c?.emailPartner1;
        }
        
        return ( e && e.length ) ? <a href={`mailto:${e}`}>{e}</a> : 'No Email';
    }

    const displayPhone = ( cid, partner = false ) => {
        const c = contacts[cid]; // .find( f => f.cid === cid );
        let p;
        
        if ( c ) {
            if ( c.phoneMobile ) {
                p = c.phoneMobile;
            } else if ( c.phone ) {
                p = c.phone;
            } else if ( c.phoneHome ) {
                p = c.phoneHome;
            }

            if ( partner ) {
                p = '';
    
                if ( c.phoneMobilePartner1 ) {
                    p = c.phoneMobilePartner1;
                } else if ( c.phonePartner1 ) {
                    p = c.phonePartner1;
                }
            }
        }
        
        return ( p && p.length ) ? <a href={`tel:${p}`}>{p}</a> : 'No Phone';
    }

    const displayBorrowerRow = ( label, cid, bid, name, partner = false ) => {
        return (
            <Row className='align-items-center'>
                <Col xs='auto' className='tf-sidebar-obj-value'>
                    {label}
                </Col>
                <Col>
                    <Row className='align-items-center'>
                        <Col xs='auto' className='p-1 ps-3 pb-0'>
                            <Link to={`/contact/${cid}`}>{name}</Link>
                        </Col>
                    </Row>
                    <Row className='align-items-center'>
                        <Col xs='auto' className='p-1 ps-3 pt-0'>{ displayEmail( cid, partner ) }</Col>
                        <Col xs='auto' className='p-0 pb-1'><BsDot /></Col>
                        <Col xs='auto' className='p-1 pt-0'>{ displayPhone( cid, partner ) }</Col>
                    </Row>
                </Col>
                <Col xs='auto'><FaRegTrashAlt className='tf-sidebar-trash' onClick={ () => trash( obj.details.lid, bid ) } /></Col>
            </Row>
        )
    }

    const AccordionSummary = styled( ( props ) => (
        <MuiAccordionSummary expandIcon={<KeyboardArrowRightSharpIcon sx={{ fontSize: '0.9rem' }} />} {...props} />
    ) ) ( ( { theme } ) => ( {
        backgroundColor:
          theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
        flexDirection: 'row-reverse',
        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            transform: 'rotate(90deg)',
        },
        '& .MuiAccordionSummary-content': {
            marginLeft: theme.spacing(1),
        },
    } ) );

    useEffect( () => {
        if ( obj.borrowers ) {
            obj.borrowers.sort( ( a, b ) => {
                if ( a.label === 'Primary' ) {
                    return -1;
                }
                if ( b.label === 'Primary' ) {
                    return 1;
                }
                return 0;
            } );
            setExpanded( obj.borrowers.length > 0 );
            setBorrs( obj.borrowers );
        }
    }, [ obj.borrowers ] );

    return (
        <Container fluid className='p-0'>
            <Accordion expanded={expanded}>
                <AccordionSummary expandIcon={<KeyboardArrowRightSharpIcon onClick={ () => setExpanded( !expanded ) } />}>
                    <Row className='align-items-center w-100'>
                        <Col><Typography>Borrowers ({borrs.length})</Typography></Col>
                        {/* <Col xs='auto' className='p-0'><Button variant='outline-primary' size='sm' onClick={ () => handleModal( 'task' ) }>+ Add</Button></Col> */}
                    </Row>
                </AccordionSummary>
                <AccordionDetails>
                    <ListGroup variant='flush'>
                    { borrs.map( ( a, idx ) => (
                        <ListGroup.Item key={idx}>
                            {
                                displayBorrowerRow( a.label, a.cid, a.bid, formatName( a.cid ) )
                            }
                            {
                                ( orgId !== 'Benchmark-Preston' ) ? (
                                    displayJungoCoBo( a.cid, a.bid )
                                ) : (
                                    null
                                )
                            }
                        </ListGroup.Item>
                    ) ) }
                    </ListGroup>
                </AccordionDetails>
            </Accordion>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    orgId: state.user.orgId,
    aid: state.user.aid,
    uid: state.user.email,
    contacts: state.contacts.byId
} );

const mapDispatch = ( dispatch ) => ( {
} );

export default connect( mapProps, mapDispatch )( Borrowers );